import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    // Use passive listener for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-dark-900/95 backdrop-blur-md shadow-lg' : 'bg-dark-900'
      }`}
    >
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2 group">
            <img
              src="/images/logo.webp"
              alt="SpinEmerge"
              className="h-10 w-auto transition-transform group-hover:scale-105"
              loading="eager"
              width="40"
              height="40"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
              SpinEmerge
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`px-3 py-2 rounded-lg transition-colors ${
                isActive('/')
                  ? 'text-primary-400 font-semibold'
                  : 'text-gray-300 hover:text-primary-400'
              }`}
            >
              Home
            </Link>
            <Link
              to="/offers"
              className={`px-3 py-2 rounded-lg transition-colors ${
                isActive('/offers')
                  ? 'text-primary-400 font-semibold'
                  : 'text-gray-300 hover:text-primary-400'
              }`}
            >
              Casino Offers
            </Link>
            <Link
              to="/comparison"
              className={`px-3 py-2 rounded-lg transition-colors ${
                isActive('/comparison')
                  ? 'text-primary-400 font-semibold'
                  : 'text-gray-300 hover:text-primary-400'
              }`}
            >
              Compare
            </Link>
            <Link
              to="/about"
              className={`px-3 py-2 rounded-lg transition-colors ${
                isActive('/about')
                  ? 'text-primary-400 font-semibold'
                  : 'text-gray-300 hover:text-primary-400'
              }`}
            >
              About
            </Link>
            <Link
              to="/faq"
              className={`px-3 py-2 rounded-lg transition-colors ${
                isActive('/faq')
                  ? 'text-primary-400 font-semibold'
                  : 'text-gray-300 hover:text-primary-400'
              }`}
            >
              FAQ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-300 hover:text-primary-400 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-800">
            <div className="flex flex-col space-y-2 pt-4">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className={`px-3 py-2 rounded-lg transition-colors ${
                  isActive('/')
                    ? 'text-primary-400 font-semibold bg-dark-800'
                    : 'text-gray-300 hover:text-primary-400 hover:bg-dark-800'
                }`}
              >
                Home
              </Link>
              <Link
                to="/offers"
                onClick={() => setIsMenuOpen(false)}
                className={`px-3 py-2 rounded-lg transition-colors ${
                  isActive('/offers')
                    ? 'text-primary-400 font-semibold bg-dark-800'
                    : 'text-gray-300 hover:text-primary-400 hover:bg-dark-800'
                }`}
              >
                Casino Offers
              </Link>
              <Link
                to="/comparison"
                onClick={() => setIsMenuOpen(false)}
                className={`px-3 py-2 rounded-lg transition-colors ${
                  isActive('/comparison')
                    ? 'text-primary-400 font-semibold bg-dark-800'
                    : 'text-gray-300 hover:text-primary-400 hover:bg-dark-800'
                }`}
              >
                Compare
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMenuOpen(false)}
                className={`px-3 py-2 rounded-lg transition-colors ${
                  isActive('/about')
                    ? 'text-primary-400 font-semibold bg-dark-800'
                    : 'text-gray-300 hover:text-primary-400 hover:bg-dark-800'
                }`}
              >
                About
              </Link>
              <Link
                to="/faq"
                onClick={() => setIsMenuOpen(false)}
                className={`px-3 py-2 rounded-lg transition-colors ${
                  isActive('/faq')
                    ? 'text-primary-400 font-semibold bg-dark-800'
                    : 'text-gray-300 hover:text-primary-400 hover:bg-dark-800'
                }`}
              >
                FAQ
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

